import {AppNotification, NotificationType} from '../types/notifications.types';
import {NOTIFICATION_TABS} from '../constants/notifications.constants';

export const filterNotificationsByTab = (notifications: AppNotification[], selectedTab: NotificationType) => {
  const tab = NOTIFICATION_TABS.find((item) => item.value === selectedTab);
  const predicate = tab?.predicate ?? ((_notification: AppNotification) => true);

  return notifications.filter((notification) => {
    if (notification.markType === 'DELETE') {
      return false;
    }

    return predicate(notification);
  });
};

export const getNewNotificationsCount = (notifications: AppNotification[]) => {
  return notifications.filter((notification) => notification.markType === 'NEW').length;
};

export const getNotificationIdsByMarkType = (notifications: AppNotification[], markType: AppNotification['markType']) => {
  return notifications.filter((notification) => notification.markType === markType).map((notification) => notification.id);
};

export const getActiveNotificationIds = (notifications: AppNotification[]) => {
  return notifications.filter((notification) => notification.markType !== 'DELETE').map((notification) => notification.id);
};

export const getNotificationById = (notifications: AppNotification[], id: string | null) => {
  if (!id) {
    return undefined;
  }

  return notifications.find((notification) => notification.id === id);
};
